import moment from "moment";
import { GQL_OfferStatus, OfferHistoryType } from "sharedTypes/offers/offers";
import { OfferStatusId } from "sharedTypes/offers/offers";

export function mapNewOffer(offer: any) {
  const _offer = { ...offer }

  if (_offer.status === GQL_OfferStatus.NEW_OFFER) {
    _offer.status = GQL_OfferStatus.LIVE_OFFER
  }

  return _offer
}

const OFFER_STATUSES_FOR_DETAILS = [
  OfferStatusId.LIVE,
  OfferStatusId.PENDING,
  OfferStatusId.ACCEPTED,
  OfferStatusId.DECLINED,
  OfferStatusId.EXPIRED,
  OfferStatusId.BIZ_COUNTER
]

export function getOfferStatusesForDetails(newOfferFlag: boolean ) {
  return newOfferFlag
    ? OFFER_STATUSES_FOR_DETAILS.concat([OfferStatusId.NEW_OFFER])
    : OFFER_STATUSES_FOR_DETAILS
}

export function selectHistoricalOfferEvents(events: OfferHistoryType[]) {
  if (!events.length) {
    return [];
  }

  const sortedEvents = [...events]
    .sort((a, b) => moment(a.on).valueOf() - moment(b.on).valueOf())

  const hasFirstEventNewOfferStatus = sortedEvents[0].status === OfferStatusId.NEW_OFFER

  if (!hasFirstEventNewOfferStatus) {
    return events;
  }

  return [...events]
    .filter(e => !(e.status === OfferStatusId.LIVE && !e.amount))
    .map(e => ({
      ...e,
      status: e.status === OfferStatusId.NEW_OFFER
        ? OfferStatusId.LIVE
        : e.status
    }))
}
